<template>
  <b-container v-if="siteApplications !== null" fluid>
    <b-row>
        <b-col>
          <div class="download-cart">
            <h4 class="title">{{ siteApplications.Windows.appTitle }}</h4>
            <p class="sub-title">{{ siteApplications.Windows.appSubTitle }}</p>
            <b-row class="download-cart-body">
              <b-col class="dawonload-cart-img">
                  <img :src="host + siteApplications.Windows.thumbnailUrl" :alt="siteApplications.Windows.appTitle">
              </b-col>
              <b-col class="download-description">
                <h4 class="description-title">{{ siteApplications.Windows.descriptionTitle }}</h4>
                <p class="descripiton-content">{{ siteApplications.Windows.descriptionContent }}</p>
                <b-link v-for="(btn, index) in siteApplications.Windows.buttons"
                  :key="index"
                  :href="btn.url.includes('http') ? btn.url : btn.url + '?t=' + new Date().getTime()"
                  :target="btn.target"
                  class="download-btn"
                  :style="{ 'background-color': btn.color || '#008490' }">
                  <i v-if="btn.hasIcon" :class="btn.icon"></i> <span class="display-name">{{ btn.title }}</span>
                </b-link>
              </b-col>
            </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="download-cart">
          <h4 class="title">{{ siteApplications.Mobile.appTitle }}</h4>
          <p class="sub-title">{{ siteApplications.Mobile.appSubTitle }}</p>
          <b-row class="download-cart-body">
            <b-col class="dawonload-cart-img">
              <img :src="host + siteApplications.Mobile.thumbnailUrl" :alt="siteApplications.Mobile.appTitle">
            </b-col>
            <b-col class="download-description">
              <h4 class="description-title">{{ siteApplications.Mobile.descriptionTitle }}</h4>
              <p class="descripiton-content">{{ siteApplications.Mobile.descriptionContent }}</p>
              <b-link v-for="(btn, index) in siteApplications.Mobile.buttons"
                :key="index"
                :href="btn.url.includes('http') ? btn.url : btn.url + '?t=' + new Date().getTime()"
                :target="btn.target"
                class="download-btn"
                :style="{ 'background-color': btn.color || '#008490' }">
                <i v-if="btn.hasIcon" :class="btn.icon"></i>
                <span class="display-name">{{ btn.title }}</span>
              </b-link>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="download-cart">
          <h4 class="title">{{ siteApplications.Github.appTitle }}</h4>
          <p class="sub-title">{{ siteApplications.Github.appSubTitle }}</p>
          <b-row class="download-cart-body">
            <b-col cols="2" class="dawonload-cart-img">
              <img class="align-middle" :src="host + siteApplications.Github.thumbnailUrl" :alt="siteApplications.Github.appTitle">
            </b-col>
            <b-col cols="10" class="github-repositories">
              <b-row>
                <b-col cols="4" v-for="(repository, index) in siteApplications.Github.githubButtons" :key="index">
                  <div class="repository">
                    <h4 class="repository-title"><b-link :href="repository.url" :target="repository.target" class="repository-link">{{ repository.title }}</b-link></h4>
                    <p class="repository-content">{{ repository.description }}</p>
                    <p class="repository-language">{{ repository.language }}</p>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="download-cart">
          <h4 class="title">{{ siteApplications.Office.appTitle }}</h4>
          <p class="sub-title">{{ siteApplications.Office.appSubTitle }}</p>
          <b-row class="download-cart-body">
            <b-col class="dawonload-cart-img">
                <img :src="host + siteApplications.Office.thumbnailUrl" :alt="siteApplications.Office.appTitle">
            </b-col>
            <b-col class="download-description">
              <h4 class="description-title">{{ siteApplications.Office.descriptionTitle }}</h4>
              <p class="descripiton-content">{{ siteApplications.Office.descriptionContent }}</p>
              <b-link v-for="(btn, index) in siteApplications.Office.buttons"
                :key="index"
                :href="btn.url.includes('http') ? btn.url : btn.url + '?t=' + new Date().getTime()"
                :target="btn.target"
                class="download-btn"
                :style="{ 'background-color': btn.color || '#008490' }">
                <i v-if="btn.hasIcon" :class="btn.icon"></i>
                <span class="display-name">{{ btn.title }}</span>
              </b-link>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="download-cart">
          <h4 class="title">{{ siteApplications.ChromeExtensions.appTitle }}</h4>
          <p class="sub-title">{{ siteApplications.ChromeExtensions.appSubTitle }}</p>
          <b-row class="download-cart-body">
            <b-col class="dawonload-cart-img">
                <img :src="host + siteApplications.ChromeExtensions.thumbnailUrl" :alt="siteApplications.ChromeExtensions.appTitle">
            </b-col>
            <b-col class="download-description">
              <h4 class="description-title">{{ siteApplications.ChromeExtensions.descriptionTitle }}</h4>
              <p class="descripiton-content">{{ siteApplications.ChromeExtensions.descriptionContent }}</p>
              <b-link v-for="(btn, index) in siteApplications.ChromeExtensions.buttons"
                :key="index"
                :href="btn.url.includes('http') ? btn.url : btn.url + '?t=' + new Date().getTime()"
                :target="btn.target"
                class="download-btn"
                :style="{ 'background-color': btn.color || '#008490' }">
                <i v-if="btn.hasIcon" :class="btn.icon"></i>
                <span class="display-name">{{ btn.title }}</span>
              </b-link>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="download-cart">
          <h4 class="title">{{ siteApplications.CMSPlugin.appTitle }}</h4>
          <p class="sub-title">{{ siteApplications.CMSPlugin.appSubTitle }}</p>
          <b-row class="download-cart-body">
            <b-col class="dawonload-cart-img">
                <img :src="host + siteApplications.CMSPlugin.thumbnailUrl" :alt="siteApplications.CMSPlugin.appTitle">
            </b-col>
            <b-col class="download-description">
              <h4 class="description-title">{{ siteApplications.CMSPlugin.descriptionTitle }}</h4>
              <p class="descripiton-content">{{ siteApplications.CMSPlugin.descriptionContent }}</p>
              <b-link v-for="(btn, index) in siteApplications.CMSPlugin.buttons"
                :key="index"
                :href="btn.url.includes('http') ? btn.url : btn.url + '?t=' + new Date().getTime()"
                :target="btn.target"
                class="download-btn"
                :style="{ 'background-color': btn.color || '#008490' }">
                <i v-if="btn.hasIcon" :class="btn.icon"></i>
                <span class="display-name">{{ btn.title }}</span>
              </b-link>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="download-cart">
          <h4 class="title">{{ siteApplications.DatabaseConverter.appTitle }}</h4>
          <p class="sub-title">{{ siteApplications.DatabaseConverter.appSubTitle }}</p>
          <b-row class="download-cart-body">
            <b-col class="dawonload-cart-img">
                <img :src="host + siteApplications.DatabaseConverter.thumbnailUrl" :alt="siteApplications.DatabaseConverter.appTitle">
            </b-col>
            <b-col class="download-description">
              <h4 class="description-title">{{ siteApplications.DatabaseConverter.descriptionTitle }}</h4>
              <p class="descripiton-content">{{ siteApplications.DatabaseConverter.descriptionContent }}</p>
              <b-link v-for="(btn, index) in siteApplications.DatabaseConverter.buttons"
                :key="index"
                :href="btn.url.includes('http') ? btn.url : btn.url + '?t=' + new Date().getTime()"
                :target="btn.target"
                class="download-btn"
                :style="{ 'background-color': btn.color || '#008490' }">
                <i v-if="btn.hasIcon" :class="btn.icon"></i>
                <span class="display-name">{{ btn.title }}</span>
              </b-link>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      siteApplications: null
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    ls_DownloadPlugins() {
      return this.$store.state.languagePack.ls_DownloadPlugins;
    }
  },

  mounted() {
    this.getSiteApplications();
  },

  methods: {
    getSiteApplications() {
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getsiteapplications", fd)
        .then(result => {
          if (result.status === 200) {
            this.siteApplications = result.body.data;
          } else {
            // console.log('Err');
          }
        });
    }
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getSiteApplications();
      }
    }
  },

  metaInfo() {
    return {
      title: this.ls_DownloadPlugins
    };
  }
};
</script>

<style lang="scss" scoped>
.download-cart {
  .title {
    font-family: 'Open Sans', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #221f20;
    margin-bottom: 6px;
  }

  .sub-title {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 16px;
    color: #6c6d70;
    margin-bottom: 20px;
  }

  .download-cart-body {
    background-color: #f7f7f7;
    border: 1px solid #e5e6e7;
    border-radius: 0.25rem;
    margin-right: 0;
    margin-left: 0;
    margin-bottom: 48px;
    padding-top: 1.875rem;
    padding-bottom: 1.875rem;

    .dawonload-cart-img {
      text-align: center;
      height: 100%;

      // img {
      //   width: 100%;
      // }
    }

    .download-description {
      .description-title {
        font-family: 'Open Sans', sans-serif;
        font-size: 18px;
        color: #706f70;
        font-weight: bold;
        margin-bottom: 16px;
      }

      .repository-link:hover {
        text-decoration: none;
      }

      .descripiton-content {
        display: inline-block;
        font-family: 'Open Sans', sans-serif;
        font-size: 0.875rem;
        margin-top: -9px;
        margin-bottom: 30px;
        color: #949495;
      }

      .download-btn {
        font-family: 'Open Sans', sans-serif;
        font-size: 1rem;
        color: #fff;
        padding: 9px 12px;
        border-radius: 3px;
        text-decoration: none;
        margin-right: 20px;
        opacity: 1;
        transition: all 0.3s ease-in-out;

        &:hover {
          opacity: 0.8;
        }

        .display-name {
          display: inline-block;
          margin-left: 10px;
        }
      }

      // .download-btn-ms {
      //   background-color: #2979ff;
      //   transition: all 0.7s;

      //   &:hover {
      //     background-color: #1c54b2;
      //   }
      // }

      // .download-btn-ios,
      // .download-btn-android {
      //   background-color: #212121;
      //   transition: all 0.7s;

      //   &:hover {
      //     background-color: #424242;
      //   }
      // }

      // .download-btn-office {
      //   background-color: #da3b01;
      //   transition: all 0.7s;

      //   &:hover {
      //     background-color: #9c2a00;
      //   }
      // }

      // .download-btn-chrome-extentions {
      //   background-color: #008395;
      //   transition: all 0.3s ease-in-out;

      //   &:hover {
      //     background-color: #026572;
      //   }
      // }
    }
  }

  .github-repositories {
    .repository {
      position: relative;
      border-radius: 0.25rem;
      border: 1px solid #f0f0f0;
      background-color: #ffffff;
      padding: 0.875rem;
      margin-bottom: 1rem;
      min-height: 9.75rem;

      .repository-title {
        font-size: 1rem;
      }

      .repository-content {
        font-size: 0.875rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }

      .repository-language {
        border-left: 0.25rem solid #00aeef;
        line-height: 1rem;
        padding: 0.25rem;
        margin-bottom: 0;
        position: absolute;
        bottom: 1rem;
        font-weight: 600;
      }
    }
  }
}

/* TRL */

.rtl-layout {
  .download-cart {
    .title,
    .sub-title,
    .description-title,
    .descripiton-content {
      direction: rtl;
      text-align: right;
    }
  }
  
  .download-cart-body {
    direction: rtl;
  }

  .download-btn {
    direction: rtl;
    text-align: right;
    margin-right: 0 !important;
    margin-left: 20px;

    .display-name {
      margin-right: 10px;
      margin-left: 0;
    }
  }
  .download-description {
    direction: rtl;
    text-align: right;
  }

  .repository {
    .repository-title,
    .repository-content {
      direction: rtl;
      text-align: right;
    }

    .repository-language {
      border-left: none !important;
      border-right: 0.25rem solid #00aeef;
      padding-top: 5px;
      line-height: 1;
    }
  }
}
</style>
